/**
 * Display helpers. All money internally is integer cents.
 */

export function dollars(cents: number | null | undefined): string {
  if (cents == null) return "—";
  const sign = cents < 0 ? "-" : "";
  const abs = Math.abs(cents);
  const whole = Math.floor(abs / 100);
  const dec = String(abs % 100).padStart(2, "0");
  return `${sign}$${whole.toLocaleString("en-US")}.${dec}`;
}

export function dollarsCompact(cents: number | null | undefined): string {
  if (cents == null) return "—";
  const v = cents / 100;
  if (Math.abs(v) >= 1_000_000)
    return `${v < 0 ? "-" : ""}$${(Math.abs(v) / 1_000_000).toFixed(2)}M`;
  if (Math.abs(v) >= 1_000)
    return `${v < 0 ? "-" : ""}$${(Math.abs(v) / 1_000).toFixed(1)}k`;
  return dollars(cents);
}

export function pct(ratio: number | null | undefined, digits = 2): string {
  if (ratio == null || Number.isNaN(ratio)) return "—";
  const v = ratio * 100;
  const sign = v >= 0 ? "+" : "";
  return `${sign}${v.toFixed(digits)}%`;
}

export function ageMinutes(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  return (Date.now() - t) / 60_000;
}

export function ageLabel(min: number | null): string {
  if (min == null) return "never";
  if (min < 1) return "just now";
  if (min < 60) return `${Math.round(min)} min ago`;
  if (min < 60 * 24) return `${Math.round(min / 60)}h ago`;
  return `${Math.round(min / (60 * 24))}d ago`;
}

/** Minutes UNTIL a future ISO timestamp; null if missing or past. */
export function minutesUntil(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return null;
  const delta = (t - Date.now()) / 60_000;
  return delta > 0 ? delta : null;
}

/** "in 12 min" / "in 3h" — used to show when a routine is next expected to fire. */
export function untilLabel(min: number | null): string {
  if (min == null) return "";
  if (min < 1) return "any moment";
  if (min < 60) return `in ${Math.round(min)} min`;
  if (min < 60 * 24) return `in ${Math.round(min / 60)}h`;
  return `in ${Math.round(min / (60 * 24))}d`;
}
